var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{staticClass:"flex-center"},[_c('transition',{attrs:{"name":"router-anim","enter-active-class":`animated fadeInUp`,"mode":"out-in","leave-active-class":`animated fadeOut`}},[_c('router-view')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }